import { Scaler } from './scaler';

export const SVG_NS = 'http://www.w3.org/2000/svg';

export interface ViewContext {
  scaler: Scaler;
  viewSide: 'ds' | 'nds';
  schematicView: boolean;
  angleThreshold: number;
}

export abstract class Part {
  abstract id: string;
  abstract children: Part[];
  abstract render(viewCtx: ViewContext): SVGElement;
  abstract update(props: any): void;
  find(id: string): Part | undefined {
    if (this.id === id) {
      return this;
    }
    for (const child of this.children) {
      const found = child.find(id);
      if (found) {
        return found;
      }
    }
    return undefined;
  }
}
